import React, { useRef } from "react";
import Webcam from "react-webcam";
import EmojiButton from "../components/EmojiButton";
import { useNavigate } from "react-router-dom";
import { API } from "../api/apiSlice";

// const title = "तपाईं हाम्रो सेवाहरू कसरी मूल्याङ्कन गर्नुहुन्छ?";

const HomePage = ({ feedback, title }) => {
  const navigate = useNavigate();
  const webcamRef = useRef(null);
  // const [imgSrc, setImgSrc] = useState(null);
  // console.log(title);

  const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "user",
  };

  const capture = React.useCallback(
    async (feedbackId, clickedAt) => {
      const imageSrc = webcamRef.current.getScreenshot();
      // setImgSrc(imageSrc);
      const data = { title: title, feedbackId, clickedAt, imageSrc };
      const responses = JSON.parse(localStorage.getItem("responses"));
      const toAdd = responses ? responses : [];
      navigate("/thankyou");
      try {
        await API.post("/submit/create", data);
        if (responses) {
          for (const entry of responses) {
            await API.post("/submit/create", entry);
          }
          localStorage.removeItem("responses");
        }
      } catch (err) {
        toAdd.push(data);
        localStorage.setItem("responses", JSON.stringify(toAdd));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [webcamRef, title]
  );

  return (
    <section className="flex flex-col gap-10 items-center justify-center min-h-[100vh] py-10">
      <h1 className="col-span-full font-bold text-[40px] text-center">
        {title}
      </h1>
      <div className="grid sm:grid-cols-12 grid-cols-6 sm:gap-10 gap-6 w-full md:px-[10%] px-[5%] justify-items-center">
        {feedback.length === 0 ? (
          <p>No feedback icons</p>
        ) : (
          feedback?.map((entry, index) => (
            <EmojiButton key={index} entry={entry} capture={capture} />
          ))
        )}
      </div>
      <Webcam
        className="absolute right-[100%]"
        muted={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
      />
      {/* {imgSrc && <img src={imgSrc} alt="" />} */}
    </section>
  );
};

export default HomePage;
